import { CURRENCY_CODE } from "@/lib/constant";
import { sendGTMEvent } from "@next/third-parties/google";
import {
  findDiscount,
  getSelectedVariants,
  getVariants,
} from "@repo/lib/helpers";
import { useFeatureFlag } from "@repo/lib/hooks/common";
import { useCallback } from "react";

const useRemoveFromCart = () => {
  const isGTMEnabled = useFeatureFlag("gtm");
  const handleRemoveFromCartEvent = useCallback(
    (product) => {
      if (!isGTMEnabled) {
        return;
      }
      const { price, sku, name, salePrice, productOptions, quantity, brand } =
        product;
      sendGTMEvent({
        event: "remove_from_cart",
        currency: CURRENCY_CODE,
        value: price,
        items: [
          {
            item_id: sku,
            item_name: name,
            affiliation: "",
            coupon: "",
            discount: findDiscount(price, salePrice),
            index: 0,
            item_brand: brand || "",
            item_category: "",
            item_category2: "",
            item_category3: "",
            item_category4: "",
            item_category5: "",
            item_list_id: "",
            item_list_name: "",
            item_variant:
              getSelectedVariants(productOptions) ||
              getVariants(productOptions),
            price,
            quantity,
          },
        ],
      });
    },
    [isGTMEnabled]
  );

  return { handleRemoveFromCartEvent };
};

export default useRemoveFromCart;
